import { RowSeatFragment } from '@websky/graphql';

import { CombinedWith } from '../model/types';
import { isSeatAvailableAndExistent } from './getIsSeatAvailableAndExistent';

export function getSeatCombinedWith(seat: RowSeatFragment, seats: RowSeatFragment[], index: number) {
	const combinedWith: CombinedWith = {};

	const prevSeat = seats?.[index - 1];
	const nextSeat = seats?.[index + 1];

	const isPrevSeatAvailable = prevSeat && isSeatAvailableAndExistent(prevSeat);
	const isNextSeatAvailable = nextSeat && isSeatAvailableAndExistent(nextSeat);

	if (seat.isAvailable && isPrevSeatAvailable) {
		combinedWith[prevSeat.number] = 'left';
	}

	if (seat.isAvailable && isNextSeatAvailable) {
		combinedWith[nextSeat.number] = 'right';
	}

	return combinedWith;
}
